import * as React from 'react';

import CareerCard from 'bundles/career-plans/components/career-card/CareerCard';
import type { OrderedCareerType } from 'bundles/career-plans/components/data/types/career-plans';

type Props = {
  orderedCareers: Array<OrderedCareerType>;
};

const CareerCards = ({ orderedCareers }: Props) => {
  return (
    <section className="rc-CareerCards">
      {orderedCareers.map((career: OrderedCareerType, index) => (
        <CareerCard key={`orderedCareer-${career.name}--${career.skillLevel}`} {...career} careerPosition={index} />
      ))}
    </section>
  );
};

export default CareerCards;
